import { useEffect } from "react";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/home/Manifesto";
import Features from "@/components/home/Features";
import SupportBanner from "@/components/home/SupportBanner";

export default function Home() {
  useEffect(() => {
    document.title = "Knot Forgotten | Boat Management App";
  }, []);

  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Manifesto />
      <Features />
      <SupportBanner />
    </div>
  );
}
